import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  headerContainer: {
    position: "relative",
    background: "#17A5B1",
    height: "140px",
    opacity: 0.88,
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "180px",
    },
  },

  title: {
    color: "white",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
    },
  },
  saveContainer: {
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      flexWrap: "wrap",
    },
  },

  saveBtn: {
    [theme.breakpoints.down("sm")]: {
      width: "25%",
      height: "30px",
    },
  },
}))

export default styles
